// Lógica personalizada para detectar desktop
// Considera desktop solo cuando el ancho de pantalla es >= 1180px
const getIsDesktop = () => {
  if (typeof window !== 'undefined') {
    return window.innerWidth >= 1180;
  }
  // Fallback para server-side rendering
  return true;
};

export default {
  navTheme: 'light',
  primaryColor: '#296DFF',
  layout: 'sidemenu',
  contentWidth: 'Fluid',
  fixedHeader: true,
  autoHideHeader: false,
  fixSiderbar: getIsDesktop(),
  menu: {
    locale: true,
  },
  title: 'AUTOMY',
  pwa: true,
  iconfontUrl: '',
  collapsedButtonRender: false,
  siderWidth: getIsDesktop() ? 304 : 0,
};
